import { Pod } from "utils/saastypes";

/** Pods of one deployment, split by whether they are running. */
export function getDeploymentStatus(
  referencePod: Pod,
  pods: Pod[]
): {
  deployment: string;
  running: string[];
  unavailable: string[];
} {
  const [deployment] = referencePod.name.split(/-[0-9a-z]{5}$/g);
  const all = pods.filter((p) => p.name.includes(deployment));
  const running = all.filter((p) => p.status === "Running").map((p) => p.name);
  const unavailable = all
    .filter((p) => p.status !== "Running")
    .map((p) => p.name);
  return { deployment, running, unavailable };
}

/** Whether deleting this pod takes its deployment to zero running replicas. */
export function isLastRunningPod(pod: Pod, pods: Pod[]): boolean {
  if (pod.status !== "Running") {
    return false;
  }
  return getDeploymentStatus(pod, pods).running.length <= 1;
}

export function isLastRunningPodByName(podName: string, pods: Pod[]): boolean {
  const pod = pods.find((p) => p.name === podName);
  return pod ? isLastRunningPod(pod, pods) : false;
}
